module.exports = {"CONFIRMATION":"confirmation","MAKE_OFFER":"makeOffer","CONTACT_DEALER":"contactDealer","ABANDON_MAKE_OFFER":"abandonMakeOffer","MAKE_PRE_AUTH_OFFER":"makePreAuthOffer","LOW_BALL":"lowBall","PRE_CONTACT_DEALER":"preContactDealer","SUCCESS_GENERIC":"successGeneric","CONTACT_DEALER_GUIDED_COPY":"contactDealerGuidedCopy","NONE":""}


//////////////////
// WEBPACK FOOTER
// ./src/contactModal/json/modalStepTypes.json
// module id = ./src/contactModal/json/modalStepTypes.json
// module chunks = 13